import { Link, useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useAuth } from "../lib/auth";
import LegalDocumentView from "../components/LegalDocumentView";
import { TERMS } from "../../../shared/terms";

export default function TermsPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="max-w-2xl mx-auto px-4 pt-6 pb-10 space-y-6">
      {user ? (
        <Link
          to="/einstellungen"
          className="inline-flex items-center gap-1 text-sm text-brand-600 hover:underline"
        >
          <ChevronLeft size={16} />
          Einstellungen
        </Link>
      ) : (
        <button
          type="button"
          onClick={() => {
            if (window.history.length > 1) navigate(-1);
            else navigate("/login");
          }}
          className="inline-flex items-center gap-1 text-sm text-brand-600 hover:underline"
        >
          <ChevronLeft size={16} />
          Zurück
        </button>
      )}
      <LegalDocumentView document={TERMS} />
    </div>
  );
}
